module.exports = __webpack_public_path__ + "static/media/42.9b0c6f3f.png";